export const POST_VIEW_ADD_TO_CART = 1
